import { Button } from "./ui/button";
import { Loader2 } from "lucide-react";
import { useTaal } from "@/contexts/TaalContext";

/** De vraag voordat er veel tegelijk gebeurt, met het aantal erin. Herstelbatch b.
 *
 *  Geen `window.confirm`: die is altijd Engels en blokkeert het venster. Dit is een
 *  regel in de kaart zelf, in de taal van de app.
 */
export default function BevestigAantal({ tekst, bezig = false, onJa, onNee }) {
  const { t } = useTaal();
  return (
    <div className="rounded-md border p-2 space-y-2" role="alertdialog" data-testid="bevestig-aantal">
      <p className="text-sm">{tekst}</p>
      <div className="flex gap-2">
        <Button size="sm" className="min-h-11 px-4" disabled={bezig} onClick={onJa} data-testid="bevestig-ja">
          {bezig && <Loader2 className="h-3 w-3 animate-spin mr-1" />}{t("Ja, doe het")}
        </Button>
        <Button size="sm" variant="outline" className="min-h-11 px-4" disabled={bezig} onClick={onNee}
                data-testid="bevestig-nee">
          {t("Nee")}
        </Button>
      </div>
    </div>
  );
}
